import { Injectable } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';
import {
  LabResult,
  LabResultQueryDto,
  LoadType
} from '@care-portals/api-interfaces';

import * as fromLabResults from './lab-results.reducer';
import * as LabResultsSelectors from './lab-results.selectors';
import * as LabResultsActions from './lab-results.actions';

@Injectable()
export class LabResultsFacade {
  loading$ = this.store.pipe(select(LabResultsSelectors.getLabResultsLoading));
  saving$ = this.store.pipe(select(LabResultsSelectors.getLabResultsSaving));
  creating$ = this.store.pipe(
    select(LabResultsSelectors.getLabResultsCreating)
  );
  allLabResults$ = this.store.pipe(
    select(LabResultsSelectors.getAllLabResults)
  );
  selectedLabResult$ = this.store.pipe(select(LabResultsSelectors.getSelected));

  constructor(private store: Store<fromLabResults.LabResultsPartialState>) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }

  loadLabResults(customerId: string) {
    this.dispatch(LabResultsActions.loadLabResults({ customerId }));
  }

  loadAllLabResults(
    filters: Partial<LabResultQueryDto>,
    loadType: LoadType = 'new'
  ) {
    this.dispatch(LabResultsActions.loadAllLabResults({ loadType, filters }));
  }

  updateLabResult(id: string, labResult: Partial<LabResult>) {
    this.dispatch(LabResultsActions.updateLabResult({ id, labResult }));
  }

  setActiveLabResult(id: string) {
    this.dispatch(LabResultsActions.setActiveLabResultId({ labResultId: id }));
  }

  openLabResultPdf(labResultId: string) {
    this.dispatch(LabResultsActions.openLabResultPdf({ labResultId }));
  }

  createLabResult(
    customerId: string,
    labResult: Partial<LabResult>,
    file?: { buffer: string; name: string; mimetype: string }
  ) {
    this.dispatch(
      LabResultsActions.createLabResult({ customerId, labResult, file })
    );
  }

  submitLabResultPdf(
    customerId: string,
    file: { buffer: string; name: string; mimetype: string }
  ) {
    this.dispatch(LabResultsActions.submitLabResultPdf({ customerId, file }));
  }
}
